


const mmopen = document.getElementById('mm__open');
const mmclose = document.getElementById('mm__close')
const overlay = document.getElementById('overlay');
const html = document.querySelector('html');

mmopen.addEventListener('click', () => {
    overlay.classList.add('active');
    html.style.overflow = 'hidden';
})


mmclose.addEventListener('click', () => {
    overlay.classList.remove('active');
    html.style.overflow = 'visible';
})


//gsap
function featuresList () {
    let features = document.querySelectorAll('.features__list li');
    let featuresArr = document.querySelectorAll('.features__textcontent')

    //Hide all boxes except the first one
    for (let i = 1; i < featuresArr.length; i++) {
        featuresArr[i].parentElement.style.display = 'none'
    }

    features.forEach((link) => {
        link.addEventListener('click', (e) => {
            features.forEach((active) => {
                active.classList.remove('active')
            })
            e.target.classList.add('active');
            featuresArr.forEach(box => {
                gsap.to(box.parentElement, {y: 50, opacity: 0, display: 'none', duration: 0})
            })
            //Show clicked box
            let activeBox = document.getElementById(e.target.getAttribute('data-target')).parentElement
            activeBox.style.display="flex";
            gsap.to(activeBox, {y: 0, opacity: 1, duration: 1})
        })
    })
}


featuresList()


/*
Accordion
 */

const acc = document.getElementsByClassName("accordion__toggler");
let i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        let panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}


//Tawk.to Button
if (document.querySelector('.tawk')) {
    document.querySelector('.tawk').addEventListener('click', () => {
        Tawk_API.toggle()
    })
}


//Scrollmagic
const controller = new ScrollMagic.Controller();


const tl_customer = gsap.timeline()
    .staggerFrom('.customers__wrapper > div', 1, {opacity: 0, y: 10,
        stagger: {
            from: 0,
            amount: 1
        }
    })

const tl_about = gsap.timeline()
    .from('.animate--left', {x: '50', opacity: 0, duration: 1.5})
    .from('.animate--right', {x: '-50', opacity: 0, duration: 1.5}, "-=1.5")

const tl_cloudfacts = gsap.timeline()
    .staggerFrom('.checklist__check li', 1, {opacity: 0, y: 10,
        stagger: {
            from: 0,
            amount: 1
        }
    })
    .from('cloud-facts .ce_image', {opacity: 0, duration: 2}, "-=2")



const customer_scene = new ScrollMagic.Scene({triggerElement: '.customer__wrapper', triggerHook: 'onEnter'})
    .setTween(tl_customer)
    .addTo(controller)
    .reverse(false)

const about_scene = new ScrollMagic.Scene({triggerElement: '#about', triggerHook: 'onEnter'})
    .setTween(tl_about)
    .addTo(controller)
    .reverse(false)

const cloudfacts_scene = new ScrollMagic.Scene({triggerElement: '.cloud-facts', triggerHook: 'onEnter'})
    .setTween(tl_cloudfacts)
    .addTo(controller)
    .reverse(false)
